import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectCoverflow,
  Scrollbar,
  Autoplay,
} from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import bluelogo from "../images/EM-LOGO_Blue.png";
import "../CSS/awareness.css";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

const GearedAwareness = () => {
  const specs = [
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Removable+Battery.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Removable+Battery+Mobile.jpg",
      title: "Long-Lasting Battery",
      desc: "Ride up to 80 KM on a single charge",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Advanced+Mechanical+Disc+Brakes.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Advanced+Mechanical+Disc+Brakes+Mobile.jpg",
      title: "Advanced Mechanical Disc Brakes",
      desc: "Stop on a dime, every time!",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Smooth+Suspension.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Smooth+Suspension+Mobile.jpg",
      title: "Smooth Suspension",
      desc: "Glide over bumps like they don’t exist",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/LED+Lights+%26+Indicators.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/LED+Lights+%26+Indicators+Mobile.jpg",
      title: "LED Lights & Indicators",
      desc: "See and be seen, day or night",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/5+Riding+Modes.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/5+Riding+Modes+Mobile.jpg",
      title: "5 Riding Modes",
      desc: "Mechanical, Throttle, PAS, Cruise & Walk Mode",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Integrated+Display.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Integrated+Display+Mobile.jpg",
      title: "Integrated Display",
      desc: "All the info you want at a glance",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Sturdy%2C+Lightweight+Frame.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Sturdy%2C+Lightweight+Frame+Mobile.jpg",
      title: "Sturdy, Lightweight Frame",
      desc: "Strong enough for adventure, light enough for fun.",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Web/Powerful+Motor.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Key+Specs/Mobile/Powerful+Motor+Mobile.jpg",
      title: "High-Torque Motor",
      desc: "250W for more vroom, less effort!",
    },
    {
      desktopImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Key+Specs/Web/7-Speed+Shimano+Gears.jpg",
      mobileImage:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Key+Specs/Mobile/7-Speed+Shimano+Gears+Mobile.jpg",
      title: "7-Speed Shimano Gears",
      desc: "Smooth-shifting on every road",
    },
  ];
  const celebs = [
    {
      name: "Nitin Gadkari",
      designation: "Minister of Road & Transport Highways",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/Screenshot+2023-10-05+115126.png",
    },
    {
      name: "Shantanu Mukherjee",
      designation: "Playback Singer",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/wdwww.png",
    },
    {
      name: "Jayant Sinha",
      designation: "Member of Indian Parliament",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/Screenshot+2023-10-05+115119.png",
    },
    {
      name: "Terence Lewis",
      designation: "Coreographer",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/Screenshot+2023-10-05+134322.png",
    },
    {
      name: "Sunil Sheity",
      designation: "Indian Actor",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/WhatsApp+Image+2023-10-03+at+13.11.png",
    },
    {
      name: "Sonali Bendre",
      designation: "Indian Actress",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/fwfwff.png",
    },
    {
      name: "Aman Gupta",
      designation: "Co-founder of Boat Lifestyle",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/011+1.png",
    },
    {
      name: "Isha Koppikar",
      designation: "Indian Actress",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/wffwFF.png",
    },
    {
      name: "Baichung Bhutia",
      designation: "Indian Former Footballer",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/gudiPadwa/Celebs/WhatsApp+Image+2023-10-05+at+12.44.png",
    },
  ];
  SwiperCore.use([
    Navigation,
    Pagination,
    EffectCoverflow,
    Scrollbar,
    Autoplay,
  ]);
  return (
    <div id="GearedAwarenessScreen">
      <div className="w-100 logo-bar">
        <div className=" desktop-nav m-0 p-0 p-3 ps-lg-5 pe-lg-5 ">
          <div className="d-flex justify-content-center ">
            <img
              src={bluelogo}
              className="img-fluid"
              style={{ width: "170px" }}
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="position-relative">
        <picture className="main-banner-img">
          <source
            media="(max-width:650px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Banner/Mobile+Banner+Gear+Cycles.jpg"
          />
          <source
            media="(min-width:651px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Banner/Web+Banner+Gear+Cycles.jpg"
          />
          <img
            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Banner/Web+Banner+Gear+Cycles.jpg"
            alt="Banner1"
            className="d-block w-100"
          />
        </picture>
        <div
          className="position-absolute d-none d-lg-block"
          style={{ top: "64%", right: "8%" }}
        >
          <Link
            to={"/bikes"}
            className="home-cta-1 text-center text-decoration-none p-3 ps-4 pe-4 ps-lg-5 pe-lg-5"
            style={{
              fontFamily: "Metropolis-bold",
              fontSize: "1.1rem",
            }}
          >
            KNOW MORE
          </Link>
        </div>
        <div className="position-absolute w-100 doodle-pro-button-banner-mobile d-lg-none">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ flexDirection: "column" }}
          >
            <div
              className="d-flex justify-content-center"
              style={{ gap: "1em" }}
            >
              <div className="btn-know-more text-uppercase rounded-5">
                <Link
                  to={"/bikes"}
                  style={{ color: "inherit" }}
                  className="my-2 text-decoration-none metropolis-bold"
                >
                  KNOW MORE
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5" style={{ backgroundColor: "#F5F5F5" }}>
        <div>
          <h2 className="text-center metropolis-bold mb-2 text-uppercase">
            <em>
              Electric. Efficient. <span className="text-em">Unstoppable.</span>
            </em>
          </h2>
          <p className="text-center">
            Why settle for just gears when you can enjoy power-assisted rides?
            <br className="d-none d-lg-block"></br>Ditch the old-school gear
            cycle and experience pedal assist, smooth shifts, and zero fuel
            cost!
          </p>
        </div>
        <div className="py-lg-4 pt-4">
          <Swiper
            spaceBetween={20}
            centeredSlides={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: true,
            }}
            slidesPerView={1.3}
            loop={true}
            simulateTouch={true}
            slide
            speed={1000}
            modules={[Navigation]}
            breakpoints={{
              1024: {
                slidesPerView: 3.3,
                spaceBetween: 30,
                pagination: false,
                loop: true,
                simulateTouch: true,
              },
            }}
          >
            {specs.map((spec) => (
              <SwiperSlide>
                <div>
                  <div className="mb-3">
                    <picture className="">
                      <source
                        media="(max-width:650px)"
                        srcSet={spec.mobileImage}
                      />
                      <source
                        media="(min-width:651px)"
                        srcSet={spec.desktopImage}
                      />
                      <img
                        src={spec.desktopImage}
                        className="img-fluid rounded-3"
                        style={{
                          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                        }}
                      />
                    </picture>
                  </div>
                  <div className="text-center">
                    <h5 className="mb-1 metropolis-medium">{spec.title}</h5>
                    <small className="text-em metropolis-medium">
                      {spec.desc}
                    </small>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="d-none d-lg-block pinned-section">
        <div
          className="py-5 awareness-usp-section d-flex align-items-center"
          style={{ overflow: "hidden" }}
        >
          <div className="w-100">
            <h2 className="text-center metropolis-bold mb-4 text-uppercase">
              <em>
                Geared. Electric. <span className="text-em">Fun.</span>
              </em>
            </h2>
            <Swiper
              spaceBetween={30}
              centeredSlides={true}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 4000,
                disableOnInteraction: true,
              }}
              slidesPerView={1.3}
              loop={false}
              simulateTouch={true}
              slide
              speed={1000}
              modules={[Pagination, Navigation]}
              breakpoints={{
                1024: {
                  slidesPerView: 3.5,
                  spaceBetween: 30,
                  pagination: true,
                  simulateTouch: true,
                },
                1600: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                  pagination: true,
                  simulateTouch: true,
                },
              }}
            >
              <SwiperSlide>
                <div className="p-2">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Accelerate+%26+Pedal.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Accelerate & Pedal
                    </h5>
                    <small className="text-em metropolis-medium">
                      Makes every ride effortless
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/7-Speed+Gear+System+%26+Motor+Power.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      7-Speed Gear System & Motor Power
                    </h5>
                    <small className="text-em metropolis-medium">
                      Better than a normal gear cycle
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Say+Yes+to+Fatigue-less+Rides.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Say Yes to Fatigue-less Rides
                    </h5>
                    <small className="text-em metropolis-medium">
                      Pedal assist for varied terrains
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Cover+up+to+80KM+on+a+Single+Charge.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Cover up to 80KM on a Single Charge
                    </h5>
                    <small className="text-em metropolis-medium">
                      Without breaking a sweat!
                    </small>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="p-2">
                  <div className="mb-3">
                    <img
                      className="img-fluid rounded-3"
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Throttle+or+Pedal+Assist_.jpg"
                    ></img>
                  </div>
                  <div className="px-2">
                    <h5 className="mb-1 metropolis-medium">
                      Throttle or Pedal Assist?
                    </h5>
                    <small className="text-em metropolis-medium">
                      For smooth rides & effortless uphill climbs
                    </small>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <div className="d-lg-none pinned-section mb-4">
        <div
          className="pt-5 text-center awareness-usp-section"
          style={{ overflow: "hidden" }}
        >
          <div className="w-100">
            <div className="">
              <h2 className="text-center metropolis-bold mb-4 text-uppercase">
                <em>
                  Safe. Fun. <span className="text-em">Electric.</span>
                </em>
              </h2>
            </div>
          </div>
        </div>
        <div>
          <Swiper
            spaceBetween={10}
            centeredSlides={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: true,
            }}
            pagination={
              ({
                clickable: true,
              },
              false)
            }
            slidesPerView={1.3}
            loop={true}
            simulateTouch={true}
            slide
            speed={1000}
            modules={[Pagination, Navigation]}
          >
            <SwiperSlide>
              <div className="p-2 pt-0">
                <div className="mb-3">
                  <img
                    className="img-fluid rounded-3"
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Accelerate+%26+Pedal.jpg"
                  ></img>
                </div>
                <div className="px-2">
                  <h5 className="mb-1 metropolis-medium">Accelerate & Pedal</h5>
                  <small className="text-em metropolis-medium">
                    Makes every ride effortless
                  </small>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="p-2 pt-0">
                <div className="mb-3">
                  <img
                    className="img-fluid rounded-3"
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/7-Speed+Gear+System+%26+Motor+Power.jpg"
                  ></img>
                </div>
                <div className="px-2">
                  <h5 className="mb-1 metropolis-medium">
                    7-Speed Gear System & Motor Power
                  </h5>
                  <small className="text-em metropolis-medium">
                    Better than a normal gear cycle
                  </small>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="p-2 pt-0">
                <div className="mb-3">
                  <img
                    className="img-fluid rounded-3"
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Say+Yes+to+Fatigue-less+Rides.jpg"
                  ></img>
                </div>
                <div className="px-2">
                  <h5 className="mb-1 metropolis-medium">
                    Say Yes to Fatigue-less Rides
                  </h5>
                  <small className="text-em metropolis-medium">
                    Pedal assist for varied terrains
                  </small>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="p-2 pt-0">
                <div className="mb-3">
                  <img
                    className="img-fluid rounded-3"
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Cover+up+to+80KM+on+a+Single+Charge.jpg"
                  ></img>
                </div>
                <div className="px-2">
                  <h5 className="mb-1 metropolis-medium">
                    Cover up to 80KM on a Single Charge
                  </h5>
                  <small className="text-em metropolis-medium">
                    Without breaking a sweat!
                  </small>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="p-2 pt-0">
                <div className="mb-3">
                  <img
                    className="img-fluid rounded-3"
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/USPs/Throttle+or+Pedal+Assist_.jpg"
                  ></img>
                </div>
                <div className="px-2">
                  <h5 className="mb-1 metropolis-medium">
                    Throttle or Pedal Assist?
                  </h5>
                  <small className="text-em metropolis-medium">
                    For smooth rides & effortless uphill climbs
                  </small>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className="overlap-section">
        <div>
          <video className="w-100" autoPlay loop muted playsInline>
            <source
              media="(max-width:650px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/GifVideo/Geared-Mobile.mp4"
              type="video/mp4"
            />
            <source
              media="(min-width:651px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/GifVideo/Geared-Desktop.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="py-5 px-lg-5 px-3" style={{ backgroundColor: "white" }}>
          <div className="text-center">
            <h2 className="text-center metropolis-bold text-uppercase">
              <em>
                Not Your Average <span className="text-em">E-Cycle</span>
              </em>
            </h2>
            <p className="mb-0">
              We’re not saying we’re the best, but we’re better than the rest!
            </p>
          </div>
          <div className="pb-4">
            <div className="row justify-content-center align-items-center">
              <div className="col-md-6 p-0">
                <div className="d-flex justify-content-center">
                  <video className="w-100" autoPlay loop muted playsInline>
                    <source
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/TREX+Pro-6_1.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
                <div>
                  <h3 className="metropolis-bold text-uppercase text-center">
                    Our Premium E-Cycles<br></br>Built to{" "}
                    <span className="text-em">Rule the Roads.</span>
                  </h3>
                </div>
              </div>
              <div className="row col-md-6 p-0">
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/battery.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        IP-Rated<br></br>Removable Battery
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/riders.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        1 Lakh+<br></br>Happy Riders
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/countries.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        Exported To<br></br>30+ Countries
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/centres.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        12+ Experience<br></br>Centers
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/india.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        Proudly Made<br></br>in India
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/production.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        In-house Component<br></br>Production
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/service.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        72-Hour Quick<br></br>Issue Resolution
                      </small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-3 p-3">
                  <div className="border border-dark p-1 w-100 rounded-3">
                    <div className="mb-2 d-flex justify-content-center">
                      <img
                        className="img-fluid"
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/icons/dealer.png"
                      ></img>
                    </div>
                    <div className="text-center" style={{ fontSize: "0.85em" }}>
                      <small>
                        550+ Dealerships<br></br>Across India
                      </small>
                    </div>
                  </div>
                </div>
                <div className="pt-3 d-flex justify-content-center">
                  <Link
                    to={"/bikes"}
                    className="btn btn-dark rounded-5 text-center text-decoration-none px-4 py-2"
                    style={{
                      fontFamily: "Metropolis-bold",
                      fontSize: "1rem",
                    }}
                  >
                    KNOW MORE
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <picture className="main-banner-img">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Breaker/Mobile+Breaker+Gear+Cycles.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Breaker/web+Breaker+Gear+Cycles.jpg"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Geared+Cycle/Breaker/web+Breaker+Gear+Cycles.jpg"
              alt="Banner1"
              className="d-block w-100"
            />
          </picture>
        </div>
        <div
          className="py-5"
          style={{ overflowX: "hidden", backgroundColor: "white" }}
        >
          <div
            className="row p-0 align-items-center"
            style={{ overflowX: "hidden" }}
          >
            <div className="col-md-3">
              <h2 className="text-center metropolis-bold mb-4 mb-lg-5 text-uppercase">
                <em>
                  They're<br></br>
                  <span className="text-em">Loving It!</span>
                </em>
              </h2>
            </div>
            <div
              className="col-md-9 py-lg-4 px-0"
              style={{ overflowX: "hidden" }}
            >
              <Swiper
                spaceBetween={20}
                centeredSlides={true}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: true,
                }}
                slidesPerView={1.3}
                loop={true}
                simulateTouch={true}
                slide
                speed={1000}
                modules={[Navigation]}
                breakpoints={{
                  1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                    pagination: true,
                    loop: false,
                    simulateTouch: true,
                  },
                }}
              >
                <SwiperSlide>
                  <div
                    className="p-2 rounded-3"
                    style={{
                      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                      border: "1px solid grey",
                    }}
                  >
                    <div className="mb-2">
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "0.6em" }}
                      >
                        <div className="w-25">
                          <img
                            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/rajesh.jpg"
                            className="img-fluid"
                          ></img>
                        </div>
                        <div>
                          <small className="metropolis-medium">Rajesh M.</small>
                          <div className="d-flex" style={{ gap: "0.1em" }}>
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-half"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0" style={{ fontSize: "0.7em" }}>
                        I’ve been using the T-Rex Pro for a few months, and I
                        love it! The motor is strong, and the ride feels smooth,
                        even when I'm on bad roads. I was unsure about getting
                        an e-cycle, but this one is truly amazing. It’s perfect
                        for city roads and off-road.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="p-2 rounded-3"
                    style={{
                      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                      border: "1px solid grey",
                    }}
                  >
                    <div className="mb-2">
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "0.6em" }}
                      >
                        <div className="w-25">
                          <img
                            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/priya.jpg"
                            className="img-fluid"
                          ></img>
                        </div>
                        <div>
                          <small className="metropolis-medium">Priya S.</small>
                          <div className="d-flex" style={{ gap: "0.1em" }}>
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0" style={{ fontSize: "0.7em" }}>
                        The Doodle V3 is just amazing for city rides! It’s small
                        but strong, and I can easily ride through traffic. The
                        battery lasts a long time because my routes are small,
                        so I don’t have to charge it every day. It's foldable so
                        I can store it anywhere.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="p-2 rounded-3"
                    style={{
                      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                      border: "1px solid grey",
                    }}
                  >
                    <div className="mb-2">
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "0.6em" }}
                      >
                        <div className="w-25">
                          <img
                            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/arjun.jpg"
                            className="img-fluid"
                          ></img>
                        </div>
                        <div>
                          <small className="metropolis-medium">Arjun K.</small>
                          <div className="d-flex" style={{ gap: "0.1em" }}>
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-rate"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                            <Icon
                              icon="ic:round-star-half"
                              style={{ color: "#ffce31" }}
                              width={"15"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <p className="mb-0" style={{ fontSize: "0.7em" }}>
                        The X1 is fast, light, and looks great, and fits my
                        budget. The pedal assist helps me take long trips. It’s
                        so smooth, and I love how quickly I can speed up. I
                        mainly use it during the weekends, and my friend is also
                        thinking of getting one after test-riding mine.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
        <div className="py-5" style={{ backgroundColor: "#F5F5F5" }}>
          <h2 className="text-center metropolis-bold mb-4 mb-lg-5 text-uppercase">
            <em>
              E-Cycles <span className="text-em">Caught Posing</span>
            </em>
          </h2>
          <div className="">
            <Swiper
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              spaceBetween={20}
              slidesPerView={1.3}
              initialSlide={0}
              centeredSlides={true}
              loop={true}
              simulateTouch={true}
              slide
              speed={1000}
              modules={[Pagination, Navigation]}
              pagination={false}
              breakpoints={{
                1024: {
                  slidesPerView: 4.5,
                  spaceBetween: 30,
                  centeredSlides: true,
                  loop: true,
                  pagination: true,
                  simulateTouch: true,
                },
                1600: {
                  slidesPerView: 6,
                  spaceBetween: 30,
                  centeredSlides: true,
                  loop: true,
                  pagination: true,
                  simulateTouch: true,
                },
              }}
            >
              {celebs.map((celeb, index) => (
                <SwiperSlide>
                  <div className="p-3 rounded-3 bg-white">
                    <div className="mb-3">
                      <img
                        className="img-fluid rounded-3"
                        src={celeb.image}
                      ></img>
                    </div>
                    <div className="text-center" style={{ height: "80px" }}>
                      <p className="metropolis-medium fw-bold mb-1">
                        {celeb.name}
                      </p>
                      <small>{celeb.designation}</small>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GearedAwareness;
